import { useEffect, useRef } from 'react';
import { useHistory } from 'umi';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

/**
 * Auto-scrolls to Pipeline Calendar when the user returns via browser Back (POP).
 */
export default function usePipelineCalendarAutoScroll(
  pipelineCalendarRef: React.RefObject<HTMLDivElement>,
  scrollStorageKey: string = STRATEGIC_STORAGE_KEY.PORTFOLIO_PIPELINE_CALENDAR_SCROLL,
) {
  const history = useHistory();
  const hasScrolled = useRef(false);

  useEffect(() => {
    if (hasScrolled.current) {
      return;
    }

    const shouldScroll = storage.getSessionStorageItem(scrollStorageKey);

    if (!shouldScroll) {
      return;
    }

    // Tab clicks and avatar redirects use PUSH; only browser Back/Forward is POP.
    if (history.action !== 'POP') {
      storage.removeSessionStorageItem(scrollStorageKey);
      return;
    }

    // Delay scroll so page layout and Pipeline Calendar can paint first.
    const timer = window.setTimeout(() => {
      if (pipelineCalendarRef.current) {
        pipelineCalendarRef.current.scrollIntoView({ behavior: 'smooth' });
        hasScrolled.current = true;
      }

      storage.removeSessionStorageItem(scrollStorageKey);
    }, 2000);

    return () => {
      window.clearTimeout(timer);
    };
  }, [pipelineCalendarRef, scrollStorageKey, history.action]);
}
